import dayjs from 'dayjs'
import { FormattedMessage } from 'react-intl'
import { Text, Button } from '@theneatcompany/nui'

import { COMPANY_NAME } from '@/constants'
import { useIntercom } from '@/components/Providers/IntercomProvider'

import styles from './Footer.module.scss'

export default function Footer() {
  const { isReady, openChat } = useIntercom()

  return (
    <footer id="footer" className={styles.footer}>
      <Text size="small" typeStyle="bold">© {dayjs().year()} {COMPANY_NAME}</Text>
      <Button onClick={() => openChat()} disabled={!isReady}><FormattedMessage id="button.chatWithUs" /></Button>
    </footer>
  )
}
